import { useTranslation, Trans } from "react-i18next";

import p1 from '../../img/Home/p1.svg';
import p2 from '../../img/Home/p2.svg';
import p3 from '../../img/Home/p3.svg';
import p4 from '../../img/Home/p4.svg';
import p5 from '../../img/Home/p5.svg';
import p6 from '../../img/Home/p6.svg';
import p7 from '../../img/Home/p7.svg';
import p8 from '../../img/Home/p8.svg';

function PlatformFeatures () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
                <p className="text-[24px] xl:text-[48px] manrope leading-[1.2] font-[500]">{t('home.7')}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[20px] mt-[30px] xl:mt-[40px]">
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p1} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.8')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.9')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p2} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.10')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.11')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p3} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.12')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.13')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p4} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.14')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.15')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p5} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.16')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.17')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p6} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.18')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.19')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p7} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.20')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.21')}</p>
                    </div>
                    <div className="flex flex-col items-start gap-[10px] xl:gap-[16px]">
                        <img src={p8} alt="" />
                        <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('home.22')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px]">{t('home.23')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlatformFeatures;